import { getDownloadURL, ref, uploadBytes, deleteObject } from "firebase/storage";
import { storage } from "../config/firebase";
import oracleLogo from '../assets/oracle-logo.png';
import amazonLogo from '../assets/amazon-logo.png';
import aidenLogo from '../assets/aiden-logo.png';
import spotifyLogo from '../assets/spotify-ful.png';


export const uploadFile = async (file, path) => {
  try {
    // Remove any "user-profiles/" prefix if it exists in the path
    const cleanPath = path.replace(/^user-profiles\//, '');

    const storageRef = ref(storage, cleanPath);
    await uploadBytes(storageRef, file);
    const url = await getDownloadURL(storageRef);
    return url;
  } catch (error) {
    console.error("Error uploading file:", error);
    throw error;
  }
};

export const removeFile = async (fileUrl) => {
  const fileRef = ref(storage, fileUrl);
  await deleteObject(fileRef);
}


export function truncateWords(text, wordLimit) {
  const words = text?.split(' ');
  const truncated = words?.slice(0, wordLimit)?.join(' ');
  return words?.length > wordLimit ? `${truncated}...` : truncated;
}

export const partners = [
  {
    name: "oracle",
    displayName: "Oracle",
    url: "https://www.oracle.com",
    image: oracleLogo
  },
  {
    name: "spotify",
    displayName: "Spotify",
    url: "https://www.spotify.com",
    image: spotifyLogo
  },
  {
    name: "aiden",
    displayName: "AIDEN",
    url: "https://www.aiden.global",
    image: aidenLogo
  },
  {
    name: "amazon",
    displayName: "Amazon",
    url: "https://www.amazon.com",
    image: amazonLogo
  }
];

export function getImageUrl(company) {
  const partner = partners.find(p => p.name.toLowerCase() === company.toLowerCase());
  if (partner) {
    return partner.image;
  }
  throw new Error('Company not found');
}

export function getPartnerByName(companyName) {
  return partners.find(p => p.name.toLowerCase() === companyName.toLowerCase());
}

export const capitalizeFirstWord = (str) => {
  if (!str) return '';
  const firstWord = str.split(' ')[0];
  return firstWord.charAt(0).toUpperCase() + firstWord.slice(1).toLowerCase();
};